import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-restaurant',
  templateUrl: './restaurant.component.html',
  styleUrls: ['./restaurant.component.css']
})
export class RestaurantComponent implements OnInit {

  meals;
  constructor() { }

  ngOnInit() {
    this.meals = [
      { imageUrl: 'assets/images/activity-3.jpg', vendor: 'KFC', meal: 'fried Chicken' },
      { imageUrl: 'assets/images/activity-3.jpg', vendor: 'Mcdonald', meal: 'Fold Over' },
      { imageUrl: 'assets/images/activity-3.jpg', vendor: 'Nandos', meal: 'Braied Meat' },
      { imageUrl: 'assets/images/activity-3.jpg', vendor: 'KFC', meal: 'fried Chicken' },
      { imageUrl: 'assets/images/activity-3.jpg', vendor: 'KFC', meal: 'fried Chicken' },
      { imageUrl: 'assets/images/activity-3.jpg', vendor: 'KFC', meal: 'fried Chicken' }
    ];
  }

}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/restaurant/restaurant.component.ts